export const Permissions = {
  create: "create:MediaFile",
  read: "read:MediaFile",
  list: "list:MediaFile",
  update: "update:MediaFile",
  delete: "delete:MediaFile",
};
